export const getNetFromGross = (grossPrice, vatRate) => {
  return round(grossPrice / ((vatRate + 100) / 100), 2);
};

export const getGrossFromNet = (netPrice, vatRate) => {
  return round(netPrice * ((vatRate + 100) / 100), 2);
};

export const round = (value, exp) => {
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math.round(value);
  }

  value = +value;
  exp = +exp;

  if (Number.isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }

  // Shift
  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] + exp : exp)));

  // Shift back
  value = value.toString().split('e');

  return +(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp));
};

export const getCurrencySymbol = currency => {
  switch (currency) {
    case 'PLN': {
      return 'zł';
    }

    default: {
      const number = Number().toLocaleString(undefined, { style: 'currency', currency });
      return number.slice(0, number.indexOf('0')).trim();
    }
  }
};

export const getDeposit = doc => {
  let valueLabel;
  let typeLabel;
  const value = doc.deposit || (doc.getDeposit && doc.getDeposit()) || 0;
  const type = doc.deposit_type || (doc.getDepositType && doc.getDepositType()) || 'percent';

  return { valueLabel, value, typeLabel, type };
};

export const getDepositAmount = doc => {
  const deposit = getDeposit(doc);
  const totalDue = getTotalDue(doc);

  if (deposit.value) {
    switch (deposit.type) {
      case 'fixed': {
        return deposit.value;
      }

      case 'percent':
      default: {
        return round(totalDue * (deposit.value / 100), 2);
      }
    }
  }
};

// get net sum
export const getSubtotal = doc => {
  let subtotal = 0;

  (doc.positions || doc.getPositions()).map(position => {
    subtotal += round((position.net_price || position.getNetPrice()) * position.quantity, 2);
  });

  return round(subtotal, 2);
};

export const getTotalDue = doc => {
  let totalDue = 0;
  (doc.positions || doc.getPositions()).map(position => {
    totalDue += round((position.gross_price || position.getGrossPrice()) * position.quantity, 2);
  });

  return round(totalDue, 2);
};

export const getNumericVatRate = position => {
  const vatRate = position.vat_rate || (position.getVatRate && position.getVatRate()) || null;
  return vatRate < 0 ? 0 : vatRate;
};
